/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AllTagsNotExistCondition } from '../../models/all-tags-not-exist-condition';
import { AlwaysTrueCondition } from '../../models/always-true-condition';
import { AnyTagExistsCondition } from '../../models/any-tag-exists-condition';
import { AnyTagIsEmptyCondition } from '../../models/any-tag-is-empty-condition';
import { AnyTagIsNotEmptyCondition } from '../../models/any-tag-is-not-empty-condition';
import { ComparingLongCondition } from '../../models/comparing-long-condition';
import { ConditionGroup } from '../../models/condition-group';
import { ContainsAllStringsCondition } from '../../models/contains-all-strings-condition';
import { ContainsAllStringsNearbyCondition } from '../../models/contains-all-strings-nearby-condition';
import { ContainsAnyStringCondition } from '../../models/contains-any-string-condition';
import { DocumentAssignedToMagnetCondition } from '../../models/document-assigned-to-magnet-condition';
import { DocumentIsStampedCondition } from '../../models/document-is-stamped-condition';
import { FixedRangeDateTimeCondition } from '../../models/fixed-range-date-time-condition';
import { FixedRangeLongCondition } from '../../models/fixed-range-long-condition';
import { FutureDateTimeCondition } from '../../models/future-date-time-condition';
import { GreaterThanOrEqualDateTimeCondition } from '../../models/greater-than-or-equal-date-time-condition';
import { LessThanOrEqualDateTimeCondition } from '../../models/less-than-or-equal-date-time-condition';
import { PastDateTimeCondition } from '../../models/past-date-time-condition';
import { SelectionContainsAllIdsCondition } from '../../models/selection-contains-all-ids-condition';
import { SelectionContainsAnyIdCondition } from '../../models/selection-contains-any-id-condition';
import { SelectionEqualsCondition } from '../../models/selection-equals-condition';
import { StartsWithAnyStringCondition } from '../../models/starts-with-any-string-condition';
import { StringEqualsCondition } from '../../models/string-equals-condition';

export interface DocumentSearchGetCondition$Params {

/**
 * GUID of the search
 */
  searchId: string;
}

export function documentSearchGetCondition(http: HttpClient, rootUrl: string, params: DocumentSearchGetCondition$Params, context?: HttpContext): Observable<StrictHttpResponse<(AllTagsNotExistCondition | AlwaysTrueCondition | AnyTagExistsCondition | AnyTagIsEmptyCondition | AnyTagIsNotEmptyCondition | ComparingLongCondition | ConditionGroup | ContainsAllStringsCondition | ContainsAllStringsNearbyCondition | ContainsAnyStringCondition | DocumentAssignedToMagnetCondition | DocumentIsStampedCondition | FixedRangeDateTimeCondition | FixedRangeLongCondition | FutureDateTimeCondition | GreaterThanOrEqualDateTimeCondition | LessThanOrEqualDateTimeCondition | PastDateTimeCondition | SelectionContainsAllIdsCondition | SelectionContainsAnyIdCondition | SelectionEqualsCondition | StartsWithAnyStringCondition | StringEqualsCondition)>> {
  const rb = new RequestBuilder(rootUrl, documentSearchGetCondition.PATH, 'get');
  if (params) {
    rb.path('searchId', params.searchId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<(AllTagsNotExistCondition | AlwaysTrueCondition | AnyTagExistsCondition | AnyTagIsEmptyCondition | AnyTagIsNotEmptyCondition | ComparingLongCondition | ConditionGroup | ContainsAllStringsCondition | ContainsAllStringsNearbyCondition | ContainsAnyStringCondition | DocumentAssignedToMagnetCondition | DocumentIsStampedCondition | FixedRangeDateTimeCondition | FixedRangeLongCondition | FutureDateTimeCondition | GreaterThanOrEqualDateTimeCondition | LessThanOrEqualDateTimeCondition | PastDateTimeCondition | SelectionContainsAllIdsCondition | SelectionContainsAnyIdCondition | SelectionEqualsCondition | StartsWithAnyStringCondition | StringEqualsCondition)>;
    })
  );
}

documentSearchGetCondition.PATH = '/document-search/{searchId}/condition';
